export const CHAT_OPENED_BY_USER = `chats/CHAT_OPENED_BY_USER`
export const CHAT_UPDATED = `chats/CHAT_UPDATED`
export const CHAT_CREATED = `chats/CHAT_CREATED`
export const IS_COMPOSING_CONTENT = `chats/IS_COMPOSING_CONTENT`
